<div class="container">
  <div class="header2">
    {{ 'MENU_EDIT.MODIFIER_GROUPS' | translate }}
  </div>
  <div>
    <button class="mat-button" (click)="onClickCreateModifierGroup()">Create modifier group</button>
    <button class="mat-button" (click)="onApplyModifierGroup()">Apply modifier group</button>
  </div>
  <mat-spinner *ngIf="loading" [diameter]="30"></mat-spinner>

  <div class="list">
    <app-modifier-group-item
      *ngFor="let mg of modifierGroups"
      [modifierGroup]="mg"
      [organization]="organization"
      [modifiers]="modifiers"
      (changedChecked)="selectModifierGroupHandler($event)"
      (loading)="onLoadingHandler($event)"
      (deleting)="onDeleteHandler($event)"
    ></app-modifier-group-item>
  </div>
</div>

